import Loader from "@/components/Loader";
import { Card, CardContent } from "@gogive/design-system";
import { currency } from "@/lib/format";
import { cn } from "@/lib/utils";
import { DeltaPill } from "./DeltaPill";
import { homeHeadlineClass } from "./homeTypography";

type Props = {
  isLoading: boolean;
  raisedCents: number;
  monthRaisedCents: number;
  donors: number;
  monthDonorsDelta: number;
  recurringRevenue: number;
  monthRecurringRevenue: number;
};

export function HomeStatsCards({
  isLoading,
  raisedCents,
  monthRaisedCents,
  donors,
  monthDonorsDelta,
  recurringRevenue,
  monthRecurringRevenue,
}: Props) {
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
      <Card>
        <CardContent>
          <div>
            <p className="mb-1 text-sm font-medium text-muted-foreground">
              Raised
            </p>
            {isLoading ? (
              <Loader size={24} />
            ) : (
              <p
                className={cn(
                  homeHeadlineClass,
                  "text-3xl font-extrabold tracking-tight text-foreground"
                )}
              >
                {currency(raisedCents / 100)}
              </p>
            )}
          </div>
          <div className="mt-4 flex items-center gap-2">
            <DeltaPill value={monthRaisedCents / 100} formatMoney />
            <span className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
              this month
            </span>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <div>
            <p className="mb-1 text-sm font-medium text-muted-foreground">
              Donors
            </p>
            {isLoading ? (
              <Loader size={24} />
            ) : (
              <p
                className={cn(
                  homeHeadlineClass,
                  "text-3xl font-extrabold tracking-tight text-foreground"
                )}
              >
                {donors}
              </p>
            )}
          </div>
          <div className="mt-4 flex items-center gap-2">
            <DeltaPill value={monthDonorsDelta} />
            <span className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
              this month
            </span>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <div>
            <p className="mb-1 text-sm font-medium text-muted-foreground">
              Recurring plans
            </p>
            {isLoading ? (
              <Loader size={24} />
            ) : (
              <p
                className={cn(
                  homeHeadlineClass,
                  "text-3xl font-extrabold tracking-tight text-foreground"
                )}
              >
                {currency(recurringRevenue)}
              </p>
            )}
          </div>
          <div className="mt-4 flex items-center gap-2">
            <DeltaPill value={monthRecurringRevenue} formatMoney />
            <span className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
              this month
            </span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
